import { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { exportCSV, exportChartPNG } from "@/lib/exports";
import { ExportBtn } from "@/components/dashboard/ExportBtn";

const tooltipStyle = { backgroundColor: "#111827", border: "1px solid #334155", borderRadius: 8, color: "#F8FAFC", fontSize: 12 };
export const YEAR_COLORS = ["#475569", "#8B5CF6", "#22D3EE", "#10B981", "#F59E0B", "#EA580C", "#3B82F6", "#F43F5E"];
const CHANNELS = [["B2C", "Counter (B2C)"], ["B2B", "Subdealers (B2B)"], ["Other", "Other"]];

export const TrendsSection = ({ monthlyStacked, monthlyStackedChannels }) => {
  const [sel, setSel] = useState(["B2C", "B2B", "Other"]);
  if (!monthlyStacked || !monthlyStackedChannels) return <div className="h-72 bg-[#1E293B] border border-[#334155] rounded-lg animate-pulse" />;
  const years = monthlyStacked.years;
  const data = monthlyStacked.data.map((row, i) => {
    const out = { month: row.month };
    years.forEach((y) => {
      out[y] = sel.reduce((t, ch) => t + ((monthlyStackedChannels[ch]?.data?.[i]?.[y]) || 0), 0);
    });
    return out;
  });
  const toggle = (ch) => setSel((s) => (s.includes(ch) ? s.filter((x) => x !== ch) : [...s, ch]));
  const label = sel.length === 3 ? "Combined (all channels)" : sel.map((c) => CHANNELS.find(([k]) => k === c)?.[1]).join(" + ") || "none selected";
  return (
    <div data-testid="yoy-stacked-chart" className="bg-[#1E293B] border border-[#334155] rounded-lg p-5">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
        <h3 className="text-lg font-semibold" style={{ fontFamily: "Outfit, sans-serif" }}>Vehicle Deliveries — Year on Year</h3>
        <span className="flex items-center gap-1.5">
          {CHANNELS.map(([k, l]) => (
            <button key={k} data-testid={`yoy-channel-${k.toLowerCase()}`} onClick={() => toggle(k)}
              className={`px-2.5 py-1 rounded-full text-[11px] border transition-colors active:scale-95 ${sel.includes(k) ? "bg-blue-600 border-blue-600 text-white" : "border-[#334155] text-slate-400 hover:text-white"}`}>
              {l}
            </button>
          ))}
          <ExportBtn onCSV={() => exportCSV(data, "deliveries-yoy")} onPNG={() => exportChartPNG("yoy-stacked-chart", "deliveries-yoy")} />
        </span>
      </div>
      <p className="text-xs text-slate-400 mb-3">Units DELIVERED per calendar month, stacked year-wise — showing: <b className="text-slate-300">{label}</b>. Toggle channel pills to compare Counter vs Subdealer vs Combined.</p>
      <ResponsiveContainer width="100%" height={340}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
          <XAxis dataKey="month" tick={{ fill: "#94A3B8", fontSize: 11 }} />
          <YAxis tick={{ fill: "#94A3B8", fontSize: 11 }} />
          <Tooltip contentStyle={tooltipStyle} cursor={{ fill: "#334155", opacity: 0.3 }} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          {years.map((y, i) => (
            <Bar key={y} dataKey={y} stackId="yr" fill={YEAR_COLORS[i % YEAR_COLORS.length]} name={y}
              radius={i === years.length - 1 ? [3, 3, 0, 0] : [0, 0, 0, 0]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
